module.exports = __webpack_public_path__ + "img/instagram_inactive.bc25b8b.png";